var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "contact_svg__a",
  d: "M6.667 12.333A.667.667 0 0 1 6 13H3a.667.667 0 1 1 0-1.333h3c.368 0 .667.298.667.666m0-4.333A.667.667 0 0 1 6 8.667H3a.667.667 0 1 1 0-1.334h3c.368 0 .667.299.667.667m2.666-3.667H3A.667.667 0 1 1 3 3h6.333a.666.666 0 1 1 0 1.333M10.057 9H9V7.943l4.333-4.333 1.057 1.057zM11 11H9.333c-1.103 0-2 .897-2 2v1.667H2A.667.667 0 0 1 1.333 14V2c0-.368.3-.667.667-.667h8.333c.368 0 .667.3.667.667v2.057L7.862 7.195a.67.67 0 0 0-.195.472v2c0 .368.298.666.666.666h2c.177 0 .347-.07.472-.195L11 9.943zm-2.333 2.724V13c0-.368.299-.667.666-.667h.724zm7.138-9.529-2-2a.666.666 0 0 0-.943 0l-.529.529V2c0-1.103-.897-2-2-2H2C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h6l.01-.001a.6.6 0 0 0 .12-.012q.024-.006.048-.014.038-.009.076-.024.025-.011.048-.025.034-.016.067-.036a.7.7 0 0 0 .102-.083l3.667-3.667a.7.7 0 0 0 .125-.18.7.7 0 0 0 .057-.161v-.002a.7.7 0 0 0 .013-.128V8.609l3.472-3.471a.666.666 0 0 0 0-.943"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "contact_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#contact_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#contact_svg__a",
  fill: "#DF0000"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#CDCACA",
  mask: "url(#contact_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})))));
export default SvgContact;